exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-size:13px;font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:#383838;-moz-osx-font-smoothing:#383838;text-align:center;color:#383838}#app{width:100wh}.rowFontSize{font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-338dd89e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 44
// module chunks = 1